import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ReactDataGrid from 'react-data-grid';
import { Data, Editors } from 'react-data-grid-addons';
import { Translate, I18n } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import { Field } from 'redux-form';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Breadcrumb,
  ButtonToolbar,
} from 'react-bootstrap';

import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../Widgets/spinner';
import GenericDatePicker from '../Common/GenericDatePicker';
import { convertTimeToUtc, convertLocalDate, getFromToDates, toFromDates  } from '../Common/cleanDates';
import { __GAPI_KEY__ } from '../Common/keys';
import SpinnerButton from '../Common/SpinnerButton';
import PrintIframe from '../Common/PrintIframe';
import DispatchMap from './DispatchMap';
import InputField from '../Common/inputField';
import { Selection, DisabledSelection, SelectionWithProps } from '../Common/selection';
import {
  fetchDrivers,
  assignDriverToRoute,
  saveDeliveryFees,
  fetchDriverCodes,
  fetchDeliveryFee,
  sendDriverInvite,
  deleteRoute,
} from '../../actions/dispatch_actions';
import { ROOT_URL } from '../../actions/root_url';

const timeOptions = [{
  label: <Translate value="forenoon" />,
  value: true,
}, {
  label: <Translate value="afternoon" />,
  value: false
}];

const {
  Draggable: {
    Container: DraggableContainer,
    RowActionsCell,
    DropTargetRowContainer,
  },
  Data: { Selectors },
} = require("react-data-grid-addons");

const { DropDownEditor } = Editors;

const RowRenderer = DropTargetRowContainer(ReactDataGrid.Row);

const propTypes = {
  rowKey: PropTypes.string,
  value: PropTypes.node,
  stopsIsLoading: PropTypes.bool,
  routesIsLoading: PropTypes.bool,
  savingStopEdits: PropTypes.bool,
  routingPdfFailure: PropTypes.bool,
  assigningOrderRoute: PropTypes.bool,
  requestingRoutingPdf: PropTypes.bool,
  pickingListPdfFailure: PropTypes.bool,
  packingListPdfFailure: PropTypes.bool,
  salesInvoicePdfFailure: PropTypes.bool,
  requestingPickingListPdf: PropTypes.bool,
  requestingPackingListPdf: PropTypes.bool,
  unassignedOrdersIsLoading: PropTypes.bool,
  requestingDispatchSalesInvoicePdf: PropTypes.bool,
  routesError: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.bool]),
  stopsError: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.bool]),
  unassignedOrdersError: PropTypes.shape({}),
  routes: PropTypes.arrayOf(PropTypes.object),
  // stops: PropTypes.shape({
  //   Active: PropTypes.arrayOf(
  //     PropTypes.shape({
  //       ActiveStopNum: PropTypes.number,
  //       City: PropTypes.string,
  //       CustomerNum: PropTypes.string,
  //       Description: PropTypes.string,
  //       IsActive: PropTypes.bool,
  //       Name: PropTypes.string,
  //     })
  //   ),
  //   DriverLocation: PropTypes.string,
  //   Inactive: PropTypes.arrayOf(
  //     PropTypes.shape({
  //       // Same as active
  //       StopNum: PropTypes.number,
  //     })
  //   ),
  //   Warehouse: PropTypes.shape({
  //     lat: PropTypes.number,
  //     lng: PropTypes.number,
  //   }),
  // }),
  dependentValues: PropTypes.shape({
    TempDate: PropTypes.string,
  }),
  unassignedOrders: PropTypes.arrayOf(PropTypes.shape({})),
  routingPdf: PropTypes.shape({}),
  pickingListPdf: PropTypes.shape({}),
  packingListPdf: PropTypes.shape({}),
  dispatchSalesInvoicePdf: PropTypes.shape({}),
  remove: PropTypes.func,
  fetchStops: PropTypes.func,
  fetchRoutes: PropTypes.func,
  saveEditedStops: PropTypes.func,
  assignOrderRoute: PropTypes.func,
  printDispatchRoute: PropTypes.func,
  fetchUnassignedOrders: PropTypes.func,
  printDispatchPickingList: PropTypes.func,
  printDispatchPackingList: PropTypes.func,
  printDispatchSalesInvoice: PropTypes.func,
};

const defaultProps = {
  value: null,
  rowKey: 'ActiveStopNum',
  stopsIsLoading: false,
  routesIsLoading: false,
  savingStopEdits: false,
  routingPdfFailure: false,
  assigningOrderRoute: false,
  requestingRoutingPdf: false,
  pickingListPdfFailure: false,
  packingListPdfFailure: false,
  salesInvoicePdfFailure: false,
  requestingPickingListPdf: false,
  requestingPackingListPdf: false,
  unassignedOrdersIsLoading: false,
  requestingDispatchSalesInvoicePdf: false,
  stopsError: {},
  routesError: {},
  routes: [],
  stops: {},
  dependentValues: {},
  unassignedOrders: [],
  routingPdf: {},
  pickingListPdf: {},
  packingListPdf: {},
  unassignedOrdersError: {},
  dispatchSalesInvoicePdf: {},
  remove: () => {},
  fetchStops: () => {},
  fetchRoutes: () => {},
  saveEditedStops: () => {},
  assignOrderRoute: () => {},
  printDispatchRoute: () => {},
  fetchUnassignedOrders: () => {},
  printDispatchPickingList: () => {},
  printDispatchPackingList: () => {},
  printDispatchSalesInvoice: () => {},
};

const contextTypes = {
  router: PropTypes.shape({}),
};

class AutoRouting extends Component {
  constructor() {
    super();
    this.state = {
      routeOptions: [],

      routes: {
        rows: [],
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      },
      activeStops: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
        selectedRowIdx: null,
      },
      inactiveStops: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
      },

      orders: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
        filters: null,
        filteredRows: [],
        selectedRow: null,
        editedRows: [],
      },

      RouteId: null,
      tabKey: 1,
      routePdfFrameLoaded: true,
      pickingListPdfFrameLoaded: true,
      packingListPdfFrameLoaded: true,
      salesInvoicePdfFrameLoaded: true,

      showGoogleMaps: false,
      centerCoordinates: {
        lat: 34.019733,
        lng: -117.958672,
      },

      routeDateChosen: new Date(),

      isOverLayLoadingActive: false,

      stopsFormData: {
        orderNo: '',
        StopIndex: null,
      }, // abort
      stopsFormModalVisible: false,
      stopsDeleteFormModalVisibility: false,
      assignDriverModalVisibility: false,
      generateRouteModalVisibility: false,

      pdfFrameLoaded: true,
    };

    this.setRouteDateChosen = this.setRouteDateChosen.bind(this);
  }

  componentDidMount() {
    this.handleFetchDrivers();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.routes && nextProps.routes !== this.props.routes) {
      const newRoutes = _.cloneDeep(nextProps.routes);
      const routes = {
        rows: newRoutes,
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      };
      this.setState({ routes });
    }

    if (nextProps.stops && nextProps.stops !== this.props.stops) {
      // const centerCoordinates = nextProps.stops.Warehouse;
      const activeStops = {
        rows: [...nextProps.stops],
        sortColumn: null,
        sortDirection: null,
        selectedRow: null,
      };

      this.setState({ activeStops });
    }


    if (
      nextProps.pdfFile &&
      nextProps.pdfFile !== this.props.pdfFile
    ) {
      this.setState({ pdfFrameLoaded: false });
    }
  }

  shouldComponentUpdate(nextState) {
    if (
      nextState.pdfFrameLoaded !==
        this.state.pdfFrameLoaded &&
      this.state.pdfFrameLoaded === false
    ) {
      return false;
    }
    return true
  }

  onPDFIFrameLoaded = () => {
    if (!this.state.pdfFrameLoaded) {
      const pdfFrame = window.frames.autRoutingPDFFrame;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ pdfFrameLoaded: true });
    }
  };

  renderPDFIFrame() {
    if (this.props.pdfFile) {
      const file = window.URL.createObjectURL(this.props.pdfFile);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.onPDFIFrameLoaded}
          id="autRoutingPDFFrame"
          name="autRoutingPDFFrame"
          src={file}
        />
      );
    }
  }


  handleFetchDrivers = (
    startDate = "1900-01-01T08:00:00.000Z",
    endDate = "3000-01-02T07:59:59.999Z"
  ) => {
    const handleSuccess = (drivers) => {
      this.setState({
        drivers,
      });
    };
    const handleFailure = () => {
      this.setState({
        drivers: [],
      });
    };
    fetchDrivers(startDate, endDate, handleSuccess, handleFailure);
  };

  handleTabSelect(tabKey) {
    this.setState({ tabKey });
  }

  toggleGoogleMaps = () => {
    this.setState({ showGoogleMaps: !this.state.showGoogleMaps });
  };

  handlePickingListPrint = () => {
    const {
      selectedRows,
    } = this.state.routes;

    this.props.printPickinglist(selectedRows[0].id);
  }

  handlePickingListAllPrint = () => {
    const {
      selectedRows,
    } = this.state.routes;

    this.props.printPickinglistAll(selectedRows[0].id);
  }

  handleDeleteRouteClick = () => {
    const {
      selectedRows,
    } = this.state.routes;
    const success = () => {
      this.setState({
        routes: {
          ...this.state.routes,
          selectedRows: [],
        },
        RouteId: null,
      }, () => {
        this.props.fetchAutoRouteStops(null);
        this.handleCheckRouteClick();
      })
    }
    deleteRoute(selectedRows[0].id, success)
  }

  removeRow(dependentValues) {
    let rows = [...this.state.activeStops.rows];
    rows = rows.filter((row) => {
      const match = row.ActiveStopNum !== dependentValues.ActiveStopNum;
      return match;
    });
    rows.map((row, index) => {
      row.ActiveStopNum = index + 1;
    });
    const activeStops = { ...this.state.activeStops, rows };
    this.setState({ activeStops });
  }

  renderRoutes() {
    if (this.props.routesIsLoading && !this.props.routesError) {
      return <Spinner />;
    } else if (this.props.routesError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger" id="dispatch-errors">
            {JSON.stringify(this.props.routesError)}
          </div>
        </ContentWrapper>
      );
    }

    const getRows = () => Data.Selectors.getRows(this.state.routes);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const routes = { ...this.state.routes, sortColumn, sortDirection };
      this.setState({ routes });
    };

    const handleRowUpdated = (e) => {
      const rows = this.state.routes.rows.slice(0);
      Object.assign(rows[e.rowIdx], e.updated);
      const routes = { ...this.state.routes, rows };
      this.setState({ routes });
    };

    const onCellSelected = (coordinates) => {
      const newRows = getRows();
      if (this.state.routes.selectedRows[0] === newRows[coordinates.rowIdx]) {
        return;
      }
      newRows.map((r) => {
        r.isSelected = false;
      });
      const selectedRows = [newRows[coordinates.rowIdx]];
      newRows[coordinates.rowIdx].isSelected = true;
      const routes = { ...this.state.routes, rows: newRows, selectedRows };
      this.setState(
        {
          routes,
          RouteId: newRows[coordinates.rowIdx].id,
        },
        () => {
          this.props.fetchAutoRouteStops(this.state.RouteId);
        },
      );
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      const selectedRows = [];
      if (this.state.routes.selectedRows[0] === rows[0]) {
        return;
      }
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
        selectedRows.push(r.row);
      });
      const routes = { ...this.state.routes, rows: newRows, selectedRows };
      this.setState({
        routes,
        RouteId: rows[0].row.id,
      }, () => {
        this.props.fetchAutoRouteStops(this.state.RouteId);
      });
    };

    const onRowsDeselected = (rows) => {
      const newRows = getRows();
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      const routes = { ...this.state.routes, rows: newRows, selectedRows: [] };
      this.setState({
        routes,
        // RouteId: 0,
      }, () => {
        // this.props.fetchAutoRouteStops(this.state.RouteId);
      });
    };

    const columns = [
      {
        key: 'RouteName',
        name: <Translate value="route_name" />,
        resizable: true,
        filterable: true,
      },
      {
        key: 'RoutedStopsCount',
        name: <Translate value="stop_counts" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'TotalItemsCount',
        name: <Translate value="item_count" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'TotalMiles',
        name: <Translate value="total_miles" />,
        resizable: true,
        sortable: true,
      },
      {
        key: 'DriverFirstName',
        name: <Translate value="driver_name" />,
        resizable: true,
        sortable: true,
      },
      {
        key: 'TotalServiceMinutes',
        name: <Translate value="service_mins" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
    ];
    const orderPoints = this.state.activeStops.rows.map((stop) => ({
      ActiveStopNum: stop.StopIndex,
      lat: stop.LatitudeY,
      lng: stop.LongitudeX,
      deliver_eta_info: {
        duration_text: stop.EtaUTC,
      },
      details: stop,
    }));
    return (
      <Row>
        {this.state.showGoogleMaps ? (
          <DispatchMap
            isMarkerShown={!_.isEmpty(this.state.activeStops.rows)}
            orderPoints={orderPoints}
            driverLocation={this.props.stops.DriverLocation}
            centerCoordinates={this.state.centerCoordinates}
            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${__GAPI_KEY__}&v=3.exp&libraries=geometry,drawing,places`}
            loadingElement={<div style={{ height: '100%' }} />}
            containerElement={<div style={{ height: '300px' }} />}
            mapElement={<div style={{ height: '100%' }} />}
          />
        ) : (
          <Col sm={12}>
            <div id="Routing-dataGrid1">
              <ReactDataGrid
                rowKey="DispatchRoute_id"
                onGridSort={handleGridSort}
                columns={columns}
                rowHeight={25}
                headerRowHeight={50}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={295}
                onRowUpdated={handleRowUpdated}
                enableRowSelect="single"
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
                onCellSelected={onCellSelected}
              />
            </div>
          </Col>
        )}
      </Row>
    );
  }

  renderStops() {
    if (this.props.stopsIsLoading && !this.props.stopsError) {
      return <Spinner />;
    } else if (this.props.stopsError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger" id="dispatch-errors">
            {JSON.stringify(this.props.stopsError)}
          </div>
        </ContentWrapper>
      );
    }

    const getRows = () =>
      Data.Selectors.getRows (
        this.state.tabKey === 1
          ? this.state.activeStops
          : this.state.inactiveStops,
      );

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      if (this.state.tabKey === 1) {
        const stops = { ...this.state.activeStops, sortColumn, sortDirection };
        this.setState({ activeStops: stops });
      } else {
        const stops = {
          ...this.state.inactiveStops,
          sortColumn,
          sortDirection,
        };
        this.setState({ inactiveStops: stops });
      }
    };

    const handleRowUpdated = (e) => {
      if (this.state.tabKey === 1) {
        const rows = this.state.activeStops.rows.slice(0);
        Object.assign(rows[e.rowIdx], e.updated);
        const stops = { ...this.state.activeStops, rows };
        this.setState({ activeStops: stops });
      } else {
        const rows = this.state.inactiveStops.rows.slice(0);
        Object.assign(rows[e.rowIdx], e.updated);
        const stops = { ...this.state.inactiveStops, rows };
        this.setState({ inactiveStops: stops });
      }
    };

    const isDraggedRowSelected = (selectedRows, rowDragSource) => {
      if (selectedRows && selectedRows.length > 0) {
        const key = this.props.rowKey;
        return (
          selectedRows.filter((r) => r[key] === rowDragSource.data[key])
            .length > 0
        );
      }
      return false;
    };

    const reorderRows = (e) => {
      const selectedRows = Selectors.getSelectedRowsByKey({
        rowKey: this.props.rowKey,
        selectedKeys: [],
        rows: this.state.activeStops.rows,
      });
      const draggedRows = isDraggedRowSelected(selectedRows, e.rowSource)
        ? selectedRows
        : [e.rowSource.data];
      const undraggedRows = this.state.activeStops.rows.filter (
        (r) => draggedRows.indexOf(r) === -1,
      );
      const args = [e.rowTarget.idx, 0].concat(draggedRows);
      Array.prototype.splice.apply(undraggedRows, args);
      undraggedRows.map((row, index) => {
        row.ActiveStopNum = index + 1;
      });
      const activeStops = { ...this.state.activeStops, rows: undraggedRows };
      const data = {
        stops: [{
          id: e.rowSource.data.id,
          index: e.rowTarget.data.StopIndex,
        }, {
          id: e.rowTarget.data.id,
          index: e.rowSource.data.StopIndex,
        }]
      };

      this.props.changeStopIndex(data, () => {
        this.setState({ activeStops });
      });
    };

    const DeleteFormatter = React.createClass({
      render() {
        if (this.props.dependentValues.TempDate) {
          return (
            <span>
              <Button
                bsStyle="danger"
                className="textAlignStyle"
                style={{ height: '23px', width: '39px', padding: '0px' }}
                onClick={() => {
                  this.props.remove(this.props.dependentValues);
                }}
              >
                X
              </Button>
            </span>
          );
        }
        return <div />;
      },
    });

    const TimeFormatter = React.createClass({
      render() {
        return this.props.value ? (
          <span>{convertLocalDate(this.props.value, "h:mm A")}</span>
        ) : (
          <span className="label label-danger">-</span>
        );
      },
    });

    const handleRowClick = (rowIdx, row) => {
      this.setState({
        activeStops: {
          ...this.state.activeStops,
          selectedRowIdx: rowIdx,
        },
      });
    };

    const columns = [
      {
        key: 'OrderNo',
        name: <Translate value="order_num" />,
        width: 95,
        resizable: true,
      },
      {
        key: 'EtaUTC',
        name: <Translate value="eta" />,
        width: 130,
        resizable: true,
      },
      {
        key: 'EtdUTC',
        name: <Translate value="etd" />,
        width: 130,
        resizable: true,
      },
      {
        key: 'Address',
        name: <Translate value="address" />,
        width: 215,
        resizable: true,
      },
    ];

    if (this.state.tabKey === 1) {
      return (
        <Row>
          <Col sm={12}>
            <DraggableContainer>
              <ReactDataGrid
                rowKey={this.props.rowKey}
                onGridSort={handleGridSort}
                rowActionsCell={RowActionsCell}
                columns={columns}
                rowHeight={25}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                handleRowC
                enableRowSelect="single"
                rowRenderer={<RowRenderer onRowDrop={reorderRows} />}
                minHeight={300}
                onRowUpdated={handleRowUpdated}
                onRowClick={handleRowClick}
              />
            </DraggableContainer>
          </Col>
        </Row>
      );
    }
    return (
      <Row>
        <Col sm={12}>
          <div id="Routing-dataGrid2">
            <ReactDataGrid
              rowKey="Product_id"
              onGridSort={handleGridSort}
              columns={columns}
              rowHeight={25}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={300}
              onRowUpdated={handleRowUpdated}
            />
          </div>
        </Col>
      </Row>
    );
  }

  // Date Filter helper functions start
  setRouteDateChosen = (routeDateChosen) => this.setState({ routeDateChosen });

  handleGenerateRouteClick = (form) => {
    const {
      MaxTotalHours,
      RouteCounts,
      ServiceMinutes,
      IsForenoon,
    } = form;
    this.setState({
      isGeneratingRoutes: true
    })
    if (isNaN(parseInt(MaxTotalHours)) || isNaN(parseInt(RouteCounts)) || isNaN(parseInt(ServiceMinutes))) {
      alert('Integer only');
      return;
    }
    const { routeDateChosen } = this.state;
    const { fromDate, toDate } = getFromToDates(routeDateChosen);
    if (!fromDate || !toDate || fromDate > toDate) {
      alert(I18n.t('please_select_a_start_date_that_is_before_the_end_date'));
      return;
    }

    const newForm = {
      MaxTotalHours: parseInt(MaxTotalHours),
      RouteCounts: parseInt(RouteCounts),
      ServiceMinutes: parseInt(ServiceMinutes),
      IsForenoon: IsForenoon.value,
    };
    newForm['startDateGenerate'] = fromDate;
    newForm['endDateGenerate'] = toDate;

    const success = () => {
      alert('Success!');
      this.setGenerateRouteModalVisibility(false);
      this.setState({
        isGeneratingRoutes: false,
      });
      this.handleCheckRouteClick();
    };
    const fail = () => {
      this.setState({
        isGeneratingRoutes: false,
      })
    }
    this.props.generateRoute(newForm, success, fail);
  };

  handleCheckRouteClick = () => {
    const { routeDateChosen } = this.state;
    const { fromDate, toDate } = getFromToDates(routeDateChosen);

    if (!fromDate || !toDate || fromDate > toDate) {
      alert(I18n.t('please_select_a_start_date_that_is_before_the_end_date'));
      return;
    }

    this.props.fetchAutoRoutes(fromDate, toDate);
  };
  // Date Filter helper functions end

  // Modals and modal helper functions
  setStopFormModalVisibility = (stopsFormModalVisible = false) =>
    this.setState({ stopsFormModalVisible });
  setStopDeleteModalVisibility = (stopsDeleteFormModalVisibility = false) =>
    this.setState({ stopsDeleteFormModalVisibility });
  setAssignDriverModalVisibility = (assignDriverModalVisibility = false) =>
    this.setState({ assignDriverModalVisibility });
  setGenerateRouteModalVisibility = (generateRouteModalVisibility = false) =>
    this.setState({ generateRouteModalVisibility });

  stopFormValidation = (form) => {
    const error = [];
    if (!form.OrderNo) {
      error.push('missing sales order number');
    }
    if (!form.StopIndex) {
      error.push('missing target stop index');
    }
    return error;
  };
  handleFormSubmit = (form) => {
    const error = this.stopFormValidation(form);
    if (error.length) {
      alert(I18n.t('form_not_valid'));
      return;
    }

    // routeId, method, data, callback
    const success = () => {
      this.props.reset();
      this.setStopFormModalVisibility(false);
      this.props.fetchAutoRouteStops(this.state.RouteId);
    };

    const payload = {
      routeId: this.state.RouteId,
      data: form,
      method: 'add',
      callback: () => {
        success();
      },
    };
    this.props.updateStopsOfAutoRoutes(payload);
  };

  handleStopDeleteSubmit = (form) => {
    const StopIds = [];
    if (
      !form.deleteStopIndex ||
      !this.state.activeStops.rows[form.deleteStopIndex - 1]
    ) {
      alert("Input iindex is not valid");
      return;
    }
    const id = this.state.activeStops.rows[form.deleteStopIndex - 1].id;
    StopIds.push(id);
    const success = () => {
      this.props.reset();
      this.setStopDeleteModalVisibility(false);
      this.props.fetchAutoRouteStops(this.state.RouteId);
    };
    const payload = {
      routeId: this.state.routes.selectedRows[0].RouteId,
      data: { StopIds },
      method: 'remove',
      callback: () => {
        success();
      },
    };
    this.props.updateStopsOfAutoRoutes(payload);
  };

  renderExportRouteButtons() {
    const { routes, routeDateChosen } = this.state;
    let id = '';
    if (routes.selectedRows.length) {
      id = routes.selectedRows[0].id;
    }
    const { fromDate, toDate } = getFromToDates(routeDateChosen);
    const token = localStorage.getItem('token');
    const exportRouteUrl = `${ROOT_URL}v1/dispatch/export-routes?RouteId=${id}&StartDeliveryDate=${fromDate}&EndDeliveryDate=${toDate}&Bearer=${token}`;

    return (
      <Button
        className="toggle-maps-button"
        bsStyle="success"
        href={exportRouteUrl}
        disabled={this.state.routeDateChosen === undefined}
        onClick={this.exportRoute}
      >
        <Translate value="export_route" />
      </Button>
    );
  }

  assignDriver = () => {
    this.props.change('route_id', this.state.RouteId);
    this.props.change('Driver_id', this.state.routes.selectedRows[0].DriverId);
    this.setAssignDriverModalVisibility(true);
  };

  handleAssignDriverSubmit = (form) => {
    if (!form.Driver_id || !form.route_id) {
      alert('Form not valid');
      return;
    }
    const success = () => {
      this.setAssignDriverModalVisibility(false);
      this.handleCheckRouteClick();
    };
    const fail = () => {
      alert('Error updating routes');
    };
    const payload = {
      Route_id: form.route_id.value || form.route_id,
      Driver_id: form.Driver_id.value || form.Driver_id,
    };
    assignDriverToRoute(payload, success, fail);
  }

  generateRoutesOptions = () => {
    if (this.state.routes.rows) {
      return this.state.routes.rows.map((route) => ({
        label: route.RouteName,
        value: route.id,
      }));
    }
    return [];
  };

  generateDriverOptions = () => {
    if (this.state.drivers) {
      return this.state.drivers.map((driver) => ({
        label: driver.name,
        value: driver.id,
      }));
    }
    return [];
  }

  renderModals = () => {
    const createDialogStyle = {
      width: '550px',
      height: '400px',
      marginLeft: '-15%',
    };
    const { handleSubmit } = this.props;
    return (
      <ContentWrapper>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.stopsFormModalVisible}
          onCloseClicked={() => {
            this.props.reset();
            this.setStopFormModalVisibility(false);
          }}
        >
          <Panel>
            <form
              method="get"
              action="#"
              onSubmit={handleSubmit(this.handleFormSubmit)}
            >
              <Row>
                <h1>
                  <Translate value="stop_form" />
                </h1>
              </Row>
              <Row>
                <Col sm={6}>
                  <div className="form-group">
                    <label>
                      <Translate value="order_number" />
                    </label>
                    <Field name="OrderNo" component={InputField} />
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="form-group">
                    <label>
                      <Translate value="stop_index" />
                    </label>
                    <Field name="StopIndex" component={InputField} />
                  </div>
                </Col>
              </Row>
              <ButtonToolbar>
                <Button
                  bsStyle="success"
                  type="submit"
                  onClick={(event) => {
                    handleSubmit(this.handleFormSubmit);
                  }}
                  disabled={false}
                >
                  <Translate value="add" />
                </Button>
                <Button
                  bsStyle="primary"
                  type="submit"
                  onClick={(event) => {
                    this.props.reset();
                    this.setStopFormModalVisibility(false);
                  }}
                  disabled={false}
                >
                  <Translate value="cancel" />
                </Button>
              </ButtonToolbar>
            </form>
          </Panel>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.stopsDeleteFormModalVisibility}
          onCloseClicked={this.setStopDeleteModalVisibility}
        >
          <Panel>
            <form
              method="get"
              action="#"
              onSubmit={handleSubmit(this.handleStopDeleteSubmit)}
            >
              <Row>
                <h1>
                  <Translate value="delete_stop" />
                </h1>
              </Row>
              <Row>
                <Col sm={6}>
                  <div className="form-group">
                    <label>
                      <Translate value="stop_index_position" />
                    </label>
                    <Field name="deleteStopIndex" component={InputField} />
                  </div>
                </Col>
              </Row>
              <ButtonToolbar>
                <Button
                  bsStyle="danger"
                  type="submit"
                  onClick={(event) => {
                    handleSubmit(this.handleStopDeleteSubmit);
                  }}
                  disabled={false}
                >
                  <Translate value="delete" />
                </Button>
                <Button
                  bsStyle="primary"
                  type="submit"
                  onClick={(event) => {
                    this.props.reset();
                    this.setStopDeleteModalVisibility(false);
                  }}
                  disabled={false}
                >
                  <Translate value="cancel" />
                </Button>
              </ButtonToolbar>
            </form>
          </Panel>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.assignDriverModalVisibility}
          onCloseClicked={this.setAssignDriverModalVisibility}
        >
          <Panel>
            <form
              method="get"
              action="#"
              onSubmit={handleSubmit(this.handleAssignDriverSubmit)}
            >
              <Row>
                <h1>
                  <Translate value="assign_driver" />
                </h1>
              </Row>
              <Row>
                <Col sm={6}>
                  <div className="form-group">
                    <label>
                      <Translate value="route_name" />
                    </label>
                    <Field
                      name="route_id"
                      component={Selection}
                      options={this.generateRoutesOptions()}
                    />
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="form-group">
                    <label>
                      <Translate value="stop_index_position" />
                    </label>
                    <Field
                      name="Driver_id"
                      component={Selection}
                      options={this.generateDriverOptions()}
                    />
                  </div>
                </Col>
              </Row>
              <ButtonToolbar>
                <Button
                  bsStyle="success"
                  type="submit"
                  onClick={(event) => {
                    handleSubmit(this.handleAssignDriverSubmit);
                  }}
                  disabled={false}
                >
                  <Translate value="assign" />
                </Button>
                <Button
                  bsStyle="primary"
                  type="submit"
                  onClick={(event) => {
                    this.props.reset();
                    this.setAssignDriverModalVisibility(false);
                  }}
                  disabled={false}
                >
                  <Translate value="cancel" />
                </Button>
              </ButtonToolbar>
            </form>
          </Panel>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.generateRouteModalVisibility}
          onCloseClicked={this.setGenerateRouteModalVisibility}
        >
          <Panel>
            <form
              method="get"
              action="#"
              onSubmit={handleSubmit(this.handleGenerateRouteClick)}
            >
              <Row>
                <h1>
                  <Translate value="generate_route" />
                </h1>
              </Row>
              <Row>
                <Col sm={6}>
                  <div className="form-group">
                    <label>
                      <Translate value="route_counts" />
                    </label>
                    <Field name="RouteCounts" component={InputField} initialValue={6} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <div className="form-group">
                    <label>
                      <Translate value="max_total_hours" />
                    </label>
                    <Field name="MaxTotalHours" component={InputField} initialValue={8} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <div className="form-group">
                    <label>
                      <Translate value="service_minutes" />
                    </label>
                    <Field name="ServiceMinutes" component={InputField} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <div className="form-group">
                    <label>
                      <Translate value="time" />
                    </label>
                    <Field name="IsForenoon" component={Selection} options={timeOptions}/>
                    {/* <Field name="test" component={InputField} /> */}
                  </div>
                </Col>
              </Row>
              <ButtonToolbar>
                <Button
                  bsStyle="success"
                  type="submit"
                  onClick={(event) => {
                    handleSubmit(this.handleGenerateRouteClick);
                  }}
                  disabled={this.state.isGeneratingRoutes}
                >
                  {
                    this.state.isGeneratingRoutes ? <Translate value="generating" /> : <Translate value="generate" />
                  }
                </Button>
                <Button
                  bsStyle="primary"
                  type="submit"
                  onClick={(event) => {
                    this.props.reset();
                    this.setGenerateRouteModalVisibility(false);
                  }}
                  disabled={false}
                >
                  <Translate value="cancel" />
                </Button>
              </ButtonToolbar>
            </form>
          </Panel>
        </SkyLightStateless>
      </ContentWrapper>
    );
  };
  // Modals and modal helper functions end
  render() {
    const { change } = this.props;
    return (
      //---------------
      // Begin HTML: Create New/Edit routing
      //---------------
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="dispatch" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="routing" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <Grid id="dispatch-routing">
          <Row>
            <Col sm={12}>
              <Panel style={{ height: '100px' }}>
                <Row>
                  <Col sm={2}>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <div className="label-and-date-picker">
                        <Translate value="time" />
                        :&nbsp;
                        <GenericDatePicker
                          setDate={this.setRouteDateChosen}
                          onChange={this.setRouteDateChosen}
                          selectedDate={this.state.routeDateChosen}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col sm={10}>
                    <SpinnerButton
                      bsStyle="primary"
                      onClick={() => this.handleCheckRouteClick()}
                      icon="fa-search"
                      translation={<Translate value="check_route" />}
                      disabled={false}
                    />
                    &nbsp;
                    <SpinnerButton
                      bsStyle="primary"
                      onClick={() => this.setGenerateRouteModalVisibility(true)}
                      loading={this.props.buttonLoadingVisible}
                      icon="fa-map"
                      translation={<Translate value="generate_route" />}
                      disabled={this.props.buttonLoadingVisible}
                    />
                    <span
                      style={{
                        color: 'red',
                        fontSize: '12px',
                        marginLeft: '4px',
                      }}
                    >
                      <Translate value="operate_time" />
                    </span>
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Panel style={{ height: '400px' }}>
                <Row>
                  <Col sm={1}>
                    <h3>
                      <Translate value="route_details" />
                    </h3>
                  </Col>
                  { this.renderExportRouteButtons() }
                  <Button
                    className="toggle-maps-button"
                    bsStyle="success"
                    disabled={this.state.routes.selectedRows.length !== 1}
                    onClick={this.assignDriver}
                  >
                    <Translate value="assign_driver" />
                  </Button>
                  <Button
                    className="toggle-maps-button"
                    bsStyle="primary"
                    onClick={this.toggleGoogleMaps}
                  >
                    <Translate value="toggle_map" />
                  </Button>
                  <Button
                    className="toggle-maps-button"
                    bsStyle="primary"
                    style={{ paddingRight: '5px' }}
                    disabled={this.state.routes.selectedRows.length !== 1}
                    onClick={this.handleDeleteRouteClick}
                  >
                    <Translate value="delete_route" />
                  </Button>
                  <Button
                    className="toggle-maps-button"
                    bsStyle="primary"
                    style={{ paddingRight: '5px' }}
                    disabled={this.state.routes.selectedRows.length !== 1}
                    onClick={this.handlePickingListPrint}
                  >
                    <Translate value="picking_list" />
                  </Button>
                  <Button
                    className="toggle-maps-button"
                    bsStyle="primary"
                    style={{ paddingRight: '5px' }}
                    disabled={this.state.routes.selectedRows.length !== 1}
                    onClick={this.handlePickingListAllPrint}
                  >
                    <Translate value="all_picking" />
                  </Button>
                </Row>
                <Row>
                  <Col sm={12}>{this.renderRoutes()}</Col>
                </Row>
              </Panel>
            </Col>
            <Col sm={6}>
              <Panel style={{ height: '400px' }}>
                <Row>
                  <Col sm={6}>
                    <h3>
                      <Translate value="stop_details" />
                    </h3>
                  </Col>
                  <Button
                    className="toggle-maps-button"
                    bsStyle="success"
                    type="submit"
                    onClick={(event) => {
                      const StopIndex = this.state.activeStops.selectedRowIdx
                        ? this.state.activeStops.selectedRowIdx + 1
                        : '1';
                      this.props.change('StopIndex', StopIndex);
                      this.setStopFormModalVisibility(true);
                    }}
                    disabled={!this.state.routes.selectedRows.length}
                  >
                    <em className="fa fa-plus" />
                    <Translate value="new_stop" />
                  </Button>
                  <Button
                    className="toggle-maps-button"
                    bsStyle="danger"
                    type="submit"
                    onClick={(event) => {
                      const deleteStopIndex = this.state.activeStops
                        .selectedRowIdx
                        ? this.state.activeStops.selectedRowIdx + 1
                        : '1';
                      this.props.change('deleteStopIndex', deleteStopIndex);
                      this.setStopDeleteModalVisibility(true);
                    }}
                    disabled={!this.state.routes.selectedRows.length}
                  >
                    <em className="fa fa-trash" />
                    <Translate value="delete_stop" />
                  </Button>
                </Row>
                <Row>
                  <Col sm={12}>{this.renderStops()}</Col>
                </Row>
              </Panel>
            </Col>
          </Row>
        </Grid>
        {this.renderPDFIFrame()}
        {this.renderModals()}
      </ContentWrapper>
    );
  }
}

AutoRouting.propTypes = propTypes;
AutoRouting.defaultProps = defaultProps;
AutoRouting.contextTypes = contextTypes;

export default AutoRouting;



// WEBPACK FOOTER //
// ./master/jsx/components/Dispatch/AutoRouting.jsx